module.exports = __webpack_public_path__ + "reverse-header-blob___xtI2w.svg";